import React from 'react';
import AdSlot, { AdSlotTargetingArguments } from './AdSlot';

interface BillboardAdSlotProps {
  adUnit: string;
  targetingArguments: AdSlotTargetingArguments;
}

export const BillboardAdWidth = 970;
export const BillboardAdHeight = 250;

const BillboardAdSlot: React.FC<BillboardAdSlotProps> = ({
  adUnit,
  targetingArguments,
}) => {
  return (
    <AdSlot
      adUnit={adUnit}
      size={[BillboardAdWidth, BillboardAdHeight]}
      targetingArguments={targetingArguments}
    />
  );
};

export default BillboardAdSlot;
